module.exports = __webpack_public_path__ + "static/yale-87caae26960edacb8485bf5f8c3282f4.png";